import { adminHttpClient } from '../../../../../commons/adminHttpClient'
import { WizardStatus } from '../../../../../../domain/wizard/wizard'

export type QsehraClassDesignWizardState = {
  id: string
  name: string
  familyAllowances: QsehraFamilyAllowanceRequest[]
  nextFamilyAllowances: QsehraFamilyAllowanceRequest[]
  reimbursementProduct?: number
  waitingPeriod?: number
  wizardStatues: WizardStatus
  reimburseAnotherEmployersPlan?: boolean
  offerSameAllowance?: boolean
  offerMaxAllowance?: boolean
  saveAllowancesState?: SaveAllowancesState
  isReimbursementProductEditable: boolean
  isWaitingPeriodEditable: boolean
  isOfferSameAllowanceEditable: boolean
}

export type QsehraFamilyAllowanceRequest = {
  familyStatusId: number
  amount?: number
}

export const enum SaveAllowancesState {
  SignUp,
  MidYear,
  Renewal,
}

export const getProductClassDesignWizardState = (productClassId: string): Promise<QsehraClassDesignWizardState> => {
  return adminHttpClient.get(`/AdminDashboard/qsehra/ClassDesign/ClassDesignWizardState/${productClassId}`)
}
